import React, { useEffect, useState } from 'react';
import validator from 'validator';

type UrlInputProps = {
  id: string;
  value: string;
  label: string;
  urlType?: 'absolute' | 'relative';
  handleFieldValue: (value: string, id?: string) => void;
};

const UrlInput = ({ id, label, value, handleFieldValue, urlType = 'relative' }: UrlInputProps) => {
  const [inputValue, setInputValue] = useState(value);
  const [error, setError] = useState(false);

  // Keep Partner async loads in sync, but retain local state so Block fields
  // (stale value props) can still be typed.
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const isValidLink = (nextValue: string) => {
    const hasAbsoluteUrl = validator.isURL(nextValue, { require_protocol: true });

    if (urlType === 'absolute') {
      return hasAbsoluteUrl;
    }

    // Button Link fields: absolute URLs (e.g. Calendly) or site-relative paths.
    // require_protocol avoids treating calendly.com/... as valid (would render as a relative href).
    return hasAbsoluteUrl || nextValue.charAt(0) === '/';
  };

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const nextValue = e.target.value.trim();
    setInputValue(nextValue);
    handleFieldValue(nextValue, id);
    setError(!isValidLink(nextValue));
  };

  return (
    <div className='space-y-3 w-full pt-5'>
      <label htmlFor={id} className={`block text-md font-medium ${error ? 'text-red-500' : 'text-gray-700'}`}>
        {error ? 'Must be a valid link' : label}
      </label>
      <input
        id={id}
        name='textField'
        type='text'
        placeholder={urlType === 'absolute' ? 'https://example.com/' : '/example'}
        value={inputValue}
        className={`flex-1 focus:ring-blue-lm focus:border-blue-lm block w-full ${
          error ? 'bg-red-00' : 'border-gray-200'
        } border-2 rounded-md sm:text-sm p-3`}
        onChange={changeHandler}
      />
    </div>
  );
};

export default UrlInput;
